function _extends() {
  _extends = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        if (Object.prototype.hasOwnProperty.call(n, r)) {
          e[r] = n[r];
        }
      }
    }
    return e;
  };
  return _extends.apply(this, arguments);
}

export { _extends as _ };
//# sourceMappingURL=5301ccd2.mjs.map
